/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { messaging_ChildBriefResponse } from './messaging_ChildBriefResponse';
import type { messaging_ConversationTargetResponse } from './messaging_ConversationTargetResponse';
import type { messaging_MessageWithSenderResponse } from './messaging_MessageWithSenderResponse';
import type { messaging_ReadReceiptResponse } from './messaging_ReadReceiptResponse';
import type { models_ConversationType } from './models_ConversationType';
import type { models_SenderType } from './models_SenderType';
export type messaging_ConversationDetailResponse = {
    allow_comments?: boolean;
    audience: messaging_ConversationDetailResponse.audience;
    /**
     * Category is general, callback_request or wellbeing_check.
     */
    category: messaging_ConversationDetailResponse.category;
    /**
     * Children is every child the thread is about, sorted by name; absent when it names none.
     */
    children?: Array<messaging_ChildBriefResponse>;
    created_at?: string;
    created_by_id?: string;
    created_by_type?: models_SenderType;
    /**
     * FirstStaffReplyAt is the time of the first employee or admin message; absent until then.
     */
    first_staff_reply_at?: string | null;
    id?: string;
    last_message_at?: string;
    message_count?: number;
    messages?: Array<messaging_MessageWithSenderResponse>;
    /**
     * MessagesHasMore reports whether older messages exist beyond this page
     * (issue #1297). Messages are returned oldest-first within the page, and the
     * default page is the NEWEST page.
     */
    messages_has_more?: boolean;
    /**
     * MessagesNextCursor is the before_message_id for the next (older) page.
     * Empty when messages_has_more is false.
     */
    messages_next_cursor?: string;
    /**
     * ReadBy is the read position of every other reader of the thread (#1924), empty when
     * nobody else opened it. Staff get each reader with name; a parent gets at most one
     * daycare entry and never another contact.
     */
    read_by: Array<messaging_ReadReceiptResponse>;
    subject?: string;
    target_id?: string;
    target_type?: string;
    /**
     * Targets is the full live target set of a staff conversation or of a parent-created family thread; absent otherwise and when no target is live.
     */
    targets?: Array<messaging_ConversationTargetResponse>;
    type?: models_ConversationType;
};
export namespace messaging_ConversationDetailResponse {
    export enum audience {
        FAMILY = 'family',
        STAFF = 'staff',
    }
    /**
     * Category is general, callback_request or wellbeing_check.
     */
    export enum category {
        GENERAL = 'general',
        CALLBACK_REQUEST = 'callback_request',
        WELLBEING_CHECK = 'wellbeing_check',
    }
}

